import React from 'react'
import { Modal } from 'react-bootstrap'

interface CalendarFilterProps {
    show: boolean,
    onClose: () => void
}

const CalendarFilter: React.FC<CalendarFilterProps> = ({ show, onClose }) => {
    return (
        <Modal show={show} onHide={onClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Filter Calendar</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex justify-content-between">
                    <h3 className="fs-2 text-secondary">Filter Calendar</h3>
                </div>
                <div className="d-flex mt-2">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label">Property</label>
                            <input type="text" className="form-control" />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label">Room</label>
                            <input type="text" className="form-control" />
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary">Clear</button>
                <button className="btn btn-primary">Apply</button>
            </Modal.Footer>
        </Modal>
    )
}

export default CalendarFilter